import { PaginatedRequestParams } from 'api';

export const NewClientsQueryKeys = {
  all: ['wallet'] as const,
  lists: () => [...NewClientsQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...NewClientsQueryKeys.lists(), filters] as const,
  details: () => [...NewClientsQueryKeys.all, 'detail'] as const,
  detail: (id: string, params?: PaginatedRequestParams) =>
    [...NewClientsQueryKeys.details(), id, params] as const,
};
